import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HotToastService } from '@ngneat/hot-toast';
import { OAuthService } from 'angular-oauth2-oidc';
import { LoginModalComponent } from 'projects/assist/src/app/users/pages/login-modal/login-modal.component';
import { AuthService } from 'projects/assist/src/app/users/services/auth.service';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  modalShow: boolean = false;

  constructor(
    private router: Router,
    private oauthService: OAuthService,
    private authService: AuthService,
    private toast: HotToastService,
    private modalService: NgbModal
  ) {}

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    //handle your auth error or rethrow
    if (err.status === 401 || err.status === 403) {
      //navigate /delete cookies or whatever
      //  window.location.href = this.authService.getLoginUrl(window.location.href)
      console.log('401');
      localStorage.removeItem('accessKey');
      if (!this.modalShow)
        //this.signIn();

        // if you've caught / handled the error, you don't want to rethrow it unless you also want downstream consumers to have to handle it as well.
        return of(err.message); // or EMPTY may be appropriate here
    } else {
      console.log('error');
      this.toast.error('Oeps, er ging iets mis. Herlaad de pagina');
      //return of(err.message);
    }
    return throwError(err);
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let authReq = req;

    // if we have a valid OAuth2 access token, use it
    const token = this.oauthService.getAccessToken();
    if (token) {
      authReq = req.clone({
        setHeaders: {
          Authorization: 'Bearer ' + token,
        },
      });
    }
    // otherwise, if this is a signin/signedin call, send your app‐key + cookies
    else if (req.url.includes('signin') || req.url.includes('signedin')) {
      authReq = req.clone({
        withCredentials: true,
        setHeaders: {
          Authorization: this.authService.getAppKey(),
        },
      });
    }
    // else leave the request untouched

    return next
      .handle(authReq)
      .pipe(catchError((err) => this.handleAuthError(err)));
  }

  signIn() {
    this.modalShow = true;
    var modal = this.modalService.open(LoginModalComponent);
    modal.dismissed.subscribe((x) => {
      this.closedSignIn();
    });
    modal.closed.subscribe((x) => {
      this.closedSignIn();
    });
  }

  closedSignIn() {
    if (!localStorage.getItem('accessKey')) {
      this.signIn();
    } else {
      this.modalShow = false;
    }
  }
}
